import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';
import {
  Box,
  Image,
  Heading,
  HashtagList,
  BoxCaseStudyHover,
  Paragraph,
} from 'components';
import { BOX_TYPES } from 'config';
import './BoxCaseStudy.scss';

class BoxCaseStudy extends Component {
  render() {
    const { additionalClass, data, id } = this.props;
    const { content, settings, type } = data;
    const {
      coverImage,
      clientLogo,
      title,
      tags,
      subtitle,
      description,
    } = content;
    const { link, tileColor, textColor } = settings;

    return (
      <Box
        link={link}
        id={id}
        backgroundColor={tileColor || 'white'}
        additionalClass={`box-case-study ${additionalClass}`}
      >
        <div
          className={`box-case-study__header box-case-study__header--${tileColor ||
            'white'} box-case-study__main-content ${
            type === BOX_TYPES.HOVER
              ? 'box-case-study__main-content--hover'
              : ''
          }`}
        >
          <LazyLoad offset={200} height={300}>
            <Image
              src={coverImage}
              alt={`${title} - case study cover`}
              additionalClass={`box-case-study__cover-image ${
                description ? '' : 'box-case-study__cover-image--large'
              }`}
              style={{
                height: `${description ? '220px' : '300px'}`,
                objectPosition: 'top center',
              }}
            />
          </LazyLoad>
          <div className={'box-case-study__logo-wrapper'}>
            <Image
              src={clientLogo}
              alt={`${title} - client logo`}
              additionalClass={'box-case-study__client-logo'}
              style={{ objectFit: 'contain', objectPosition: 'left top' }}
            />
          </div>
        </div>
        <div
          className={`box-case-study__content box-case-study__main-content ${
            type === BOX_TYPES.HOVER
              ? 'box-case-study__main-content--hover'
              : ''
          }`}
        >
          <div>
            <Heading
              type={3}
              size={'medium-plus-small'}
              color={textColor || 'black'}
              additionalClass={'box-case-study__title'}
            >
              {ReactHtmlParser(title)}
            </Heading>
          </div>
          {subtitle && (
            <Heading
              type={3}
              size={'small-plus'}
              color={textColor || 'white'}
              additionalClass={'box-case-study__subtitle'}
            >
              {ReactHtmlParser(subtitle)}
            </Heading>
          )}
          {description && (
            <Paragraph
              color={textColor || 'white'}
              additionalClass={'box-case-study__description'}
            >
              {ReactHtmlParser(description)}
            </Paragraph>
          )}
          {tags && (
            <div
              className={`box-case-study__tags box-case-study__tags--${textColor}`}
            >
              <HashtagList color={textColor || 'black'} data={tags} />
            </div>
          )}
        </div>
        <div
          className={`box-case-study__hover-content ${
            type === BOX_TYPES.HOVER
              ? 'box-case-study__hover-content--hover'
              : ''
          }`}
        >
          <BoxCaseStudyHover
            header={subtitle}
            content={description}
            hover={type === BOX_TYPES.HOVER}
          />
        </div>
      </Box>
    );
  }
}

BoxCaseStudy.defaultProps = {
  additionalClass: '',
};

BoxCaseStudy.propTypes = {
  data: PropTypes.shape().isRequired,
  additionalClass: PropTypes.string,
};

export default BoxCaseStudy;
